import { render, staticRenderFns } from "./headerList.vue?vue&type=template&id=2d1d6b84&"
import script from "./headerList.vue?vue&type=script&lang=js&"
export * from "./headerList.vue?vue&type=script&lang=js&"
import style0 from "./headerList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports